import { writable, get } from 'svelte/store';
export const gameHistory = writable([]);

export const updateHistoryLine = betInfo => {
    gameHistory.update(_history => [
        {
            win: betInfo?.win,
            multiplier: betInfo?.multiplier || 0,
            color: betInfo?.color,
            colorMultiplier: betInfo.bet_color && betInfo?.multiplier_color,
            isWinColor: betInfo?.win_color,
            bonusGameType: betInfo?.bonus_game_type
        },
        ..._history
    ]);

    const $updatedGameHistory = get(gameHistory);

    // if gameHistory.length >= 25 crop first 30 element & get it
    if ($updatedGameHistory.length >= 25) {
        gameHistory.update(_history => $updatedGameHistory.slice(0, 25));
    }
};
